
import { Options, Vue } from 'vue-class-component';
import Popper from 'vue3-popper';
import mapConfig from "@/config/map";
import RegionService from "@/services/RegionService";
import NavigationService from '@/services/NavigationService';
import { formatDatetimeWithDayLabel, formatDateWithDayLabel, formatTime } from "@/utils/helpers";
import { Course, CourseEnrollment } from "@/data/course";
import { Appointment } from "@/data/appointments";
import RegionCourses from "@/components/RegionCourses.vue";
import CourseEnrollmentStatus from "@/components/CourseEnrollmentStatus.vue";
import CourseSpecialInfo from "@/components/CourseSpecialInfo.vue";
import CourseService from "@/services/CourseService";


@Options({
    props: {
        course: {
            type: [Object, null],
            required: true,
        },
        /*courseEnrollment: {
            type: Object,
            required: true,
        },*/
        shown: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        Popper,
        CourseEnrollmentStatus,
        RegionCourses,
        CourseSpecialInfo,
    },
    methods: {
        formatDatetimeWithDayLabel,
        formatDateWithDayLabel,
        formatTime,
    },
    emits: [
        'close',
        'enrollmentStatusChange',
    ],
})
export default class CourseEnrollmentModal extends Vue {
    course!: Course|null
    // courseEnrollment!: CourseEnrollment

    shown!: boolean
    //showCoursesButton = false

    //regionStale = true

    appointments: Appointment[]|null = null

    loadingAppointments = false

    showAppointments = false

    currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    })

    closeModal() {
        this.$emit('close');
    }

    onEnrollmentStatusChange() {
        this.$emit('enrollmentStatusChange');
    }

    /*
    loadEnrollmentState() {
        this.loading = true;
        return RegionService.getRegion(this.regionId as number).then(result => {
            this.regionLocal = result.data?.data;
        }).finally(() => this.loading = false);
    }
    */

    toggleAppointments(): void {
        this.showAppointments = !this.showAppointments;
    }

    loadAppointments(): void {
        if( !this.course ) {
            return;
        }

        if( this.course.mode !== 1 ) {
            return; // course is not "closed" so we do not need to load all appointments
        }

        this.loadingAppointments = true;
        CourseService.getCourseAppointments(this.course.id).then(result => {
            this.appointments = result.data?.data;
        }).finally(() => this.loadingAppointments = false);
    }

    /*getRegisterUrl(courseId: number) {
        return this.regionLocal ? NavigationService.buildRouteUrl('register', { region: this.regionLocal.id, course: courseId }) : '#';
    }*/

    get description() {
        return /*this.course?.info_text ||*/ this.course?.course_type.description || null;
    }

    get descriptionLines() {
        if( !this.description ) {
            return [];
        }

        return this.description.split("\n");
    }

    mounted() {
        /*
        this.$watch('region', (newRegion: OptionalDistanceRegion|null) => {
            this.regionLocal = JSON.parse(JSON.stringify(newRegion));
        }, { immediate: true });

        this.$watch('regionId', (newRegionId: number|null) => {
            this.regionStale = true;
            / *if( newRegionId ) {
                this.$nextTick(this.loadRegion);
            }* /
        }, { immediate: true });
        */

        this.$watch('shown', (newShown: boolean) => {
            if( newShown ) {
                //console.log(this.appointment);
                //this.loadEnrollmentState();
                //console.log('tmp SHOW MODAL CourseEnrollmentModal');
            }
        });

        this.$watch('course', () => {
            this.appointments = null;
            this.loadAppointments();
        }, {
            immediate: true
        });
    }
}
